import React from "react";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { motion } from "framer-motion";
import "./Introduction.scss";

function Introduction() {
  const highlights = [
    {
      title: "AI full-stack builder",
      description: "Ships across UI, APIs, and agent workflows — from extensions to production platforms.",
    },
    {
      title: "Systems architect",
      description: "Designs micro-frontends, streaming pipelines, and reliability patterns that scale with the product.",
    },
    {
      title: "Problem solver",
      description: "Breaks down ambiguous engineering problems into clear, measurable, shippable outcomes.",
    },
  ];

  const focusAreas = ["Micro-frontends", "Multi-agent systems", "Geospatial workflows", "3D visualization"];

  const marqueeItems = ["Coding", "Systems", "AI", "Football", "Music", "Problem solving"];

  const marqueeLine = `${marqueeItems.join(". ")}. `;

  return (
    <div className="hero">
      <div className="hero__marquee" aria-hidden="true">
        <div className="hero__marquee-track">
          <span>{marqueeLine}</span>
          <span>{marqueeLine}</span>
        </div>
      </div>

      <div className="hero__content section-shell">
        <div className="hero__main">
          <motion.div
            className="hero__copy"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
          >
            <span className="hero__eyebrow">Software Engineer II at EagleView</span>
            <h1>Mihir Saini</h1>
            <p className="hero__lead">
              Software Engineer specializing in agentic and multi-agent AI systems, distributed backend architecture, and micro-frontend platforms – from POC to production at scale.
            </p>

            <div className="hero__focus" aria-label="Primary focus areas">
              {focusAreas.map((area) => (
                <span className="pill" key={area}>
                  {area}
                </span>
              ))}
            </div>

            <div className="button-row hero__actions">
              <a className="button button--primary" href="#work-details">
                View experience
                <ArrowForwardRoundedIcon fontSize="small" />
              </a>
              <a className="button button--secondary" href="#project-details">
                See projects
              </a>
              {/* <a className="button button--accent" href="/resume.pdf" download="Mihir Saini Resume.pdf">
                <DownloadRoundedIcon fontSize="small" />
                Resume
              </a> */}
            </div>
          </motion.div>

          <motion.div
            className="hero__portrait"
            aria-hidden="true"
            initial={{ opacity: 0, x: 64 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          >
            <div className="hero__portrait-frame">
              <img src="/photo-cropped.png" alt="" />
            </div>
          </motion.div>
        </div>

        <motion.div
          className="hero__pillars"
          aria-label="How I work"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.25, ease: "easeOut" }}
        >
          {highlights.map((highlight) => (
            <div className="hero__pillar" key={highlight.title}>
              <strong>{highlight.title}</strong>
              <span>{highlight.description}</span>
            </div>
          ))}
        </motion.div>
      </div>

      <motion.a
        className="hero__scroll"
        href="#Projects"
        aria-label="Scroll to projects"
        whileHover={{ y: -2 }}
        whileTap={{ scale: 0.96 }}
      >
        <KeyboardArrowDownRoundedIcon fontSize="medium" />
      </motion.a>
    </div>
  );
}

export default Introduction;
